export default [
  {
    path: "event/:event_id",
    name: "event.page",
    component: () => import("@pages/event/Event"),
  },
];
